import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const CheckListIcon: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.33398 4.5H14.0007"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M7.33398 8.5H14.0007"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M7.33398 12.5H14.0007"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M2 5.42792C2 5.42792 2.66667 5.86246 3 6.49935C3 6.49935 4 3.99935 5.33333 3.16602"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 12.7619C2 12.7619 2.66667 13.1965 3 13.8333C3 13.8333 4 11.3333 5.33333 10.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
